/* eslint-disable prettier/prettier */
export const dsar = {
  title: "Data Subject Action Request",
  paragraph:
    "The personal data required by this form is necessary to enable Demyst (‘Demyst’) to process your Data Subject Action Request. The information you supply will only be used for the purposes of identifying the personal data you are requesting and for responding to your request, in accordance with the EU General Data Protection Regulation (‘GDPR’). It may be shared with our legal and administrative teams in the United States for processing and preparing a response, subject to the EU Standard Contractual clauses for our intra-group transfers, and it will be stored securely until the relevant procedures are completed.",
  fields: [
    { label: "Full name", id: "full_name", type: "text", component: "input", required: true },
    {
      label: "Former names (if applicable)",
      id: "former_names",
      type: "text",
      component: "input",
      required: false,
    },
    { label: "Email address", id: "email", type: "email", component: "input", required: true },
    { label: "Phone number", id: "phone", type: "text", component: "input", required: true },
    {
      label: "Date of birth",
      id: "birthdate",
      type: "date",
      component: "datepicker",
      required: true,
    },
    { label: "Current address", id: "current_address", component: "textarea", required: true },
    {
      label: "Previous address",
      id: "is_previous_address",
      component: "retractable",
      type: "checkbox",
      required: false,
    },
    {
      label: "Previous address",
      id: "previous_address",
      component: "retractabletextarea",
      controller: "is_previous_address",
      required: false,
    },
    {
      label: "Please select one of the following:",
      id: "is_data_subject",
      component: "singlechoice",
      options: [
        "I am the Data Subject and can provide evidence of my identity and address",
        "I am not the Data Subject, but am acting on the Data Subject's behalf as their personal representative. I have written authority, which I can provide, along with evidence of my identity and address.",
      ],
      required: false,
    },
    {
      label:
        "To help us respond to your request, please identify your relationship with Demyst Data, Ltd",
      id: "relationship",
      component: "textarea",
      required: false,
    },
    {
      label: "Full name of Data Subject",
      id: "detail_name",
      type: "text",
      component: "input",
      required: true,
    },
    {
      label: "Former names of Data Subject (if applicable)",
      id: "detail_former",
      type: "text",
      component: "input",
      required: false,
    },
    {
      label: "Email address of Data Subject",
      id: "detail_email",
      type: "email",
      component: "input",
      required: true,
    },
    {
      label: "Phone number of Data Subject",
      id: "detail_phone",
      type: "text",
      component: "input",
      required: true,
    },
    {
      label: "Date of birth of Data Subject",
      id: "detail_birthdate",
      type: "date",
      component: "datepicker",
      required: true,
    },
    {
      label: "Current address of Data Subject",
      id: "detail_current_address",
      component: "textarea",
      required: true,
    },
    {
      label: "Previous address of Data Subject",
      id: "detail_previous_address",
      component: "textarea",
      required: false,
    },
    {
      label: "(A) The right of access",
      id: "isA",
      component: "retractable",
      type: "checkbox",
      required: false,
    },
    {
      label: "",
      id: "textA",
      component: "retractabletextarea",
      controller: "isA",
      required: false,
    },
    {
      label: "(B) The right to rectification",
      id: "isB",
      component: "retractable",
      type: "checkbox",
      required: false,
    },
    {
      label: "",
      id: "textB",
      component: "retractabletextarea",
      controller: "isB",
      required: false,
    },
    {
      label: "(C) The right to erasure",
      id: "isC",
      component: "retractable",
      type: "checkbox",
      required: false,
    },
    {
      label: "",
      id: "textC",
      component: "retractabletextarea",
      controller: "isC",
      required: false,
    },
    {
      label: "(D) The right to restrict processing",
      id: "isD",
      component: "retractable",
      type: "checkbox",
      required: false,
    },
    {
      label: "",
      id: "textD",
      component: "retractabletextarea",
      controller: "isD",
      required: false,
    },
    {
      label: "(E) The right to data portability",
      id: "isE",
      component: "retractable",
      type: "checkbox",
      required: false,
    },
    {
      label: "",
      id: "textE",
      component: "retractabletextarea",
      controller: "isE",
      required: false,
    },
    {
      label: "(F) The right to object",
      id: "isF",
      component: "retractable",
      type: "checkbox",
      required: false,
    },
    {
      label: "",
      id: "textF",
      component: "retractabletextarea",
      controller: "isF",
      required: false,
    },
    {
      label:
        "(G) The right not to be subject to decisions based solely on automated decision-making",
      id: "isG",
      component: "retractable",
      type: "checkbox",
      required: false,
    },
    {
      label: "",
      id: "textG",
      component: "retractabletextarea",
      controller: "isG",
      required: false,
    },
    {
      label: "Date of previous DSAR",
      id: "previous_date",
      type: "date",
      component: "datepicker",
      required: false,
    },
    {
      label: "Reference # of previous DSAR",
      id: "previous_reference",
      type: "text",
      component: "input",
      required: false,
    },
    {
      label: "Full name previous DSAR was made under",
      id: "previous_name",
      type: "text",
      component: "input",
      required: false,
    },
    {
      label: "Signature",
      id: "declaration_signature",
      type: "text",
      component: "input",
      required: true,
    },
    {
      label: "Date",
      id: "declaration_date",
      type: "date",
      component: "datepicker",
      required: true,
    },
  ],
  form: {
    title: "Personal Information Request Form",
    data_subject: {
      title: "Are you the Data Subject?",
      ensurance:
        "To ensure that we are releasing data to the right person, please provide us with sufficient identification, in accordance with applicable law, to confirm that you are entitled to the information requested under the GDPR.",
      nature:
        "The nature of the identification required will depend on the nature of your request and your relationship with Demyst. For example, if you are an Demyst employee or fee earner, please provide your employee number or other work-related information that can be used to identify you. If you are a third party with no affiliation with Demyst, please provide at least two forms of identification sufficient to authenticate your identity and physical address.",
      identification:
        "Any identification documents sent to us should be transmitted through secure means of communication and should be photocopies or scanned images (do not send the originals).",
      decline:
        "If you do not provide adequate proof of identity, we reserve the right to decline to provide the requested personal data.",
    },
    detail_data_subject: {
      title: "Details of the Data Subject",
    },
    rights: {
      title: "Rights pursued",
      identify:
        "Identify which right(s) you are pursuing and, in the space provided below, describe the specific information/action you are requesting.",
      details:
        "Please provide as much detail as possible, such as relevant dates, references, etc.",
      note:
        "Please note that if you are making a Data Subject Action Request and the information you request reveals details directly or indirectly about another person, we will need to seek the consent of that person before we can disclose that information to you. In certain circumstances, where disclosure of part or all of the information you have requested would adversely affect the rights and freedoms of others, we may not be able to disclose the information to you, in which case you will be informed promptly and given full reasons for that decision. Please further note that information covered by a legal professional privilege or obligation cannot be disclosed.",
      other_types:
        "Other types of Data Subject Action Requests are subject to certain conditions and exceptions. We will advise you in writing if we believe that your Data Subject Action Request fails to meet the requirements of the GDPR in whole or in part.",
      circumstances:
        "In most circumstances, Demyst will provide you with a copy of the information requested free of charge. However, Demyst may be permitted to charge a reasonable fee if a Data Subject Action Request is repetitive or manifestly unfounded or excessive. Demyst also may charge a reasonable fee to comply with Data Subject Action Requests for further copies of the same information. The fee will be based on the administrative cost of providing the information.",
    },
    previous: {
      title: "Previous Data Subject Action Requests (if applicable)",
      note:
        "Please note – This section only applies if Demyst has made a previous Data Subject Action Request (DSAR) disclosure for you.",
    },
    declaration: {
      title: "Declaration",
      declaration:
        "I declare that the information given by me is correct to the best of my knowledge, and that I am entitled to make the request identified above under the terms of the GDPR.",
    },
    button_text: "Submit",
  },
  errors: {
    field_required: "This field is required!",
    incorrect_mail: "This email address is incorrect.",
  },
};
